<template>
    <div v-if="$store.state.isModalOpenThree" class="modal fade show my-2" aria-labelledby="addNewCardTitle" style="display: block; background: #1c1d1c33">
        <div class="modal-dialog modal-md modal-dialog-centered" ref="modalRef">
            <div class="modal-content">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex justify-content-between px-1 my-1 align-item-center">
                          <h4 class="mb-0">Dental Schedule</h4>
                            <button
                                @click="onClickClose"
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                    </div>
                </div>

                <hr class="mt-0 mb-0">

                <div class="pb-2">
                  <div class="row mx-2 mt-2">
                    <div class="table-responsive">
                      <table class="table table-bordered">
                       <tbody>
                         <tr>
                           <td>Patient Name</td>
                           <td>{{ singleActivity.patient_name }}</td>
                         </tr>
                         <tr>
                           <td>Patient ID</td>
                           <td>{{ singleActivity.patient_serial_no }}</td>
                         </tr>
                         <tr>
                           <td>Gender</td>
                           <td class="text-capitalize">{{ singleActivity.patient_gender }}</td>
                         </tr>
                         <tr>
                           <td>Mobile No</td>
                           <td>{{ singleActivity.patient_mobile_no }}</td>
                         </tr>
                         <tr>
                           <td>Age</td>
                           <td>{{ singleActivity.patient_age }}</td>
                         </tr>
                         <tr>
                           <td>Service Name</td>
                           <td>{{ singleActivity.product_name }}</td>
                         </tr>
                         <tr>
                           <td>Doctor Name</td>
                           <td>{{ singleActivity.doctor_name }}</td>
                         </tr>
                         <tr>
                           <td>Schedule Date</td>
                           <td>{{ singleActivity.start_time }}</td>
                         </tr>

                         <tr>
                           <td>Amount</td>
                           <td>{{ singleActivity.total_sale_amount }}</td>
                         </tr>
                       </tbody>

                      </table>
                    </div>
                    </div>

                    <div v-if="showActions" class="row mx-2 mt-1">
                      <div class="col-12 text-end">
                        <button
                            @click="onClickEdit"
                            type="button"
                            class="btn btn-primary btn-sm mr-1"
                            title="Edit Appointment"
                        >Edit</button>
                        <button
                            @click="onClickCancel"
                            type="button"
                            class="btn btn-outline-danger btn-sm mx-1"
                            title="Cancel Appointment"
                        >Cancel</button>
                      </div>
                    </div>
                 </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, ref } from "vue";
import { useStore } from "vuex";

const props = defineProps({
  singleActivity:{
      type:Object,
      default:{}
    }
});
const emit = defineEmits(['submitted', 'onEdit', 'onCancel'])

const $store = useStore();
const modalRef = ref(null);
const showActions = computed(() => {
  if (!props.singleActivity) return false;
  if (props.singleActivity.type !== 'dental_appointment') return false;
  return props.singleActivity.status !== 'completed';
});
const onClickClose = () => {
    emit('submitted')
    $store.state.isModalOpenThree = false;
}
const onClickEdit = () => {
    emit('onEdit', props.singleActivity);
}
const onClickCancel = () => {
    if (!confirm('Are you sure you want to cancel this appointment?')) return;
    emit('onCancel', props.singleActivity);
}
</script>
